import { useState } from "react";
import { FilePdf, Share, FloppyDisk, Copy, Check } from "@phosphor-icons/react";

function ShareLinkButton({ slug }) {
  const [copied, setCopied] = useState(false);
  const onClick = async () => {
    const url = `${window.location.origin}/p/${slug}`;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      alert(url);
    }
  };
  return (
    <button onClick={onClick} className="border border-volt text-volt px-3 py-3 inline-flex items-center gap-2 text-xs uppercase tracking-widest" data-testid="copy-share-link-btn" title="Copy public link">
      {copied ? <Check size={14} weight="bold" /> : <Copy size={14} weight="bold" />}
      <span className="font-mono normal-case tracking-normal">/p/{slug}</span>
    </button>
  );
}

export default function PlanToolbar({ plan, update, onExportPDF, onToggleShare, onSave }) {
  return (
    <div className="flex flex-wrap justify-between items-end gap-4 mb-8">
      <div className="flex-1 min-w-[260px]">
        <div className="label-mono mb-1">// {plan.type.toUpperCase()}</div>
        <input
          value={plan.name} onChange={(e) => update({ name: e.target.value })}
          className="font-display text-4xl sm:text-5xl font-black uppercase bg-transparent border-b border-border focus:border-volt focus:outline-none w-full pb-1"
          data-testid="plan-name-input"
        />
        <div className="grid sm:grid-cols-2 gap-3 mt-4 max-w-2xl">
          <input value={plan.goal || ""} onChange={(e) => update({ goal: e.target.value })} placeholder="Goal" className="bg-secondary border border-border px-3 py-2 focus:outline-none focus:border-volt" data-testid="plan-goal-input" />
          <select value={plan.level || "Intermediate"} onChange={(e) => update({ level: e.target.value })} className="bg-secondary border border-border px-3 py-2 focus:outline-none focus:border-volt" data-testid="plan-level-select">
            <option>Beginner</option><option>Intermediate</option><option>Advanced</option>
          </select>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <button onClick={onExportPDF} className="border border-border px-4 py-3 font-display uppercase tracking-widest hover:border-volt hover:text-volt inline-flex items-center gap-2" data-testid="export-pdf-btn">
          <FilePdf size={18} weight="bold" /> PDF
        </button>
        <button onClick={onToggleShare} className={`border px-4 py-3 font-display uppercase tracking-widest inline-flex items-center gap-2 ${plan.is_public ? "border-volt text-volt" : "border-border hover:border-volt hover:text-volt"}`} data-testid="share-toggle-btn">
          <Share size={18} weight="bold" /> {plan.is_public ? "Public" : "Share"}
        </button>
        {plan.is_public && plan.share_slug && <ShareLinkButton slug={plan.share_slug} />}
        <button onClick={onSave} className="bg-volt text-black px-6 py-3 font-display uppercase tracking-widest font-bold hover:bg-white inline-flex items-center gap-2" data-testid="save-plan-btn">
          <FloppyDisk size={18} weight="bold" /> Save Plan
        </button>
      </div>
    </div>
  );
}
